/// <reference path="../../../../../typings/index.d.ts" />
///<reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts"/>


module Meevo.Plugins.YieldManagementProgram {

    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import WeekdayNameEnum = Meevo.Model.WeekdayNameEnum;
    import MemberStatusEnum = Meevo.Model.MemberStatusEnum;

    export interface IProgramTimeBand {
        dayOfWeek: WeekdayNameEnum;
        startTime: Date;
        endTime: Date;
        programAdjustmentOverride: ProgramAdjustmentOverrideEnum;
        adjustment: number;

    }

    export interface IYMClientType {
        clientTypeId: string;
        displayName: string;
    }

    export interface IYMMembership {
        membershipId: string;
        displayName: string;
    }

    interface IGroupedByDayAdjustment {
        dayOfWeek: number;
        adjustments: ProgramTimeRange[];
    }

    export interface IYMProgram extends Model.DataMaintenance {
        id?: string;
        displayName: string;
        programId: string;
        startDate: Date;
        endDate: Date;
        dayOfWeekBW?: number;
        strategyId: string;
        backgroundOverlay: string;
        automaticallyApplyDiscount: boolean;
        ignoreMembershipBenefitTemplate: boolean;
        ignoreItemOnSaleDiscount: boolean;
        memberStatus?: MemberStatusEnum;
        filterByClientType: boolean;
        exclusionDates: Date[];
        programTimeRanges: ProgramTimeRange[];
        membershipIds: string[];
        clientTypeIds: string[];
        memberships?: IYMMembership[];
        clientTypes?: IYMClientType[];
        programServices: ProgramServices[];
        employeeIds: string[];
        displayOverlay: boolean;
        isAllMembershipsSelected?: boolean;
        isAllClientTypesSelected?: boolean;
    }

    export class YMProgramModel implements IYMProgram {
        id?: string;
        displayName: string;
        programId: string;
        startDate: Date = new Date();
        endDate: Date;
        strategyId: string;
        objectState: ObjectStateEnum = ObjectStateEnum.Active;
        backgroundOverlay: string = '#000000';
        automaticallyApplyDiscount: boolean;
        ignoreMembershipBenefitTemplate: boolean;
        ignoreItemOnSaleDiscount: boolean;
        memberStatus: MemberStatusEnum = MemberStatusEnum.All;
        filterByClientType: boolean = false;
        exclusionDates: Date[] = [];
        programTimeRanges: ProgramTimeRange[] = [];
        membershipIds: string[] = [];
        clientTypeIds: string[] = [];
        programServices: ProgramServices[];
        employeeIds: string[] = [];
        memberships?: IYMMembership[] = [];
        clientTypes?: IYMClientType[] = [];
        homeLocationId: number;
        locationId: number;
        displayOverlay: boolean = true;
        isAllMembershipsSelected?: boolean;
        isAllClientTypesSelected?: boolean;

        get dayOfWeekBW() {
            const daysSet = new Set(
                (this.programTimeRanges || []).map((row) => row.dayOfWeek)
            );

            return Array
                .from(daysSet)
                .reduce((dayOfWeekBW, day) => {
                    return dayOfWeekBW + Math.pow(2, day - 1);
                }, 0);
        }

        set dayOfWeekBW(value) {
            // nothing to do here
        }

        get filterByClientTypeModel() {
            return this.filterByClientType;
        }

        set filterByClientTypeModel(value: boolean) {
            this.clientTypeIds = [];
            this.filterByClientType = value;
        }

        get memberStatusModel() {
            return this.memberStatus;
        }

        set memberStatusModel(value: MemberStatusEnum) {
            this.membershipIds = [];
            this.memberStatus = value;
        }

        get isValid(): boolean {
            if (!this.programTimeRanges || this.programTimeRanges.length === 0) return true;

            const groupedByDayAdjustments: IGroupedByDayAdjustment[] = this.programTimeRanges.reduce((result: IGroupedByDayAdjustment[], timeRange: ProgramTimeRange) => {
                const item: IGroupedByDayAdjustment = result.find(_row => _row.dayOfWeek === timeRange.dayOfWeek) || (() => {
                    const _item: IGroupedByDayAdjustment = {
                        dayOfWeek: timeRange.dayOfWeek,
                        adjustments: []
                    };

                    result.push(_item);

                    return _item;
                })();

                item.adjustments.push(timeRange);

                return result;
            }, [] as IGroupedByDayAdjustment[]);

            return groupedByDayAdjustments
                .map((row) => {
                    return row
                        .adjustments
                        .map((programTimeRange: ProgramTimeRange) => {
                            programTimeRange.validate(row.adjustments);

                            return programTimeRange.valid;
                        })
                        .filter((res) => !res)
                        .length === 0;
                })
                .reduce((res, current) => {
                    return res && current;
                }, true);
        }

        constructor(program: IYMProgram) {
            Object.assign(this, program || {});

            this.programServices = this.prepareServices((<IProgramServices[]>program.programServices || []));
            this.programTimeRanges = (program.programTimeRanges || []).map((row) => new ProgramTimeRange(row));
        }

        private prepareServices(programServices: IProgramServices[]): ProgramServices[] {
            let parentServices = programServices.filter((service: IProgramServices) => !Model.Guard.isSomething(service.locationId));

            parentServices.forEach((service) => {
                service.coProgramAdjustmentOverride = service.programAdjustmentOverride;
                service.coAdjustment = service.adjustment;
                let override = programServices.find((s: IProgramServices) => s.serviceId === service.serviceId && Model.Guard.isSomething(s.locationId));

                if (!!override) {
                    service.programAdjustmentOverride = override.programAdjustmentOverride;
                    service.adjustment = override.adjustment;
                }
            });

            return (parentServices).map((row) => new ProgramServices(row));
        }

    }
}
